import { Address, Category } from '@shared/types';
import {
    locationsWithGeoCoordinates,
    LocationWithGeoCoordinates,
} from '../../../../../services/search/locationFilter';

export type PageBreadcrumb = {
    key: string;
    label: string;
    url: string;
};

export type PageBreadcrumbList = {
    [key: string]: PageBreadcrumb;
};

const getLocationPageBreadcrumb = (
    city: string,
    coursesLink: string,
    primaryCategory?: Category | null
): PageBreadcrumb => {
    const isKnownLocation: LocationWithGeoCoordinates | undefined =
        locationsWithGeoCoordinates.find(
            (location: LocationWithGeoCoordinates) => location.name === city
        );
    const initialLink: string = primaryCategory
        ? `${coursesLink}/${primaryCategory.slug}`
        : `${coursesLink}`;
    if (isKnownLocation) {
        return {
            key: 'location',
            label: isKnownLocation.name,
            url: `${initialLink}/in-${isKnownLocation.name}`,
        };
    } else {
        return {
            key: 'location',
            label: city,
            url: `${initialLink}/near-${city}`,
        };
    }
};

export const getPageBreadcrumbs = (
    address: Address | null,
    coursesLink: string,
    primaryCategory: Category | null
): PageBreadcrumbList => {
    const basicPageBreadcrumb = {
        courses: {
            key: 'courses',
            label: 'Courses',
            url: coursesLink,
        },
    };

    return {
        ...basicPageBreadcrumb,
        ...(primaryCategory && {
            primaryCategory: {
                key: 'category',
                label: primaryCategory.name,
                url: `${coursesLink}/${primaryCategory.slug}`,
            },
        }),
        ...(address &&
            'city' in address &&
            address.city && {
                primaryLocation: getLocationPageBreadcrumb(
                    address.city,
                    coursesLink,
                    primaryCategory
                ),
            }),
    };
};
